import {
  defineComponent,
  reactive,
  watch,
  getCurrentInstance
} from '@vue/composition-api'
import RichUtil from '@/pages/Survey/components/RichUtil/index.vue'
import { STR_TYPE } from '../../config'
import {
  changeIsAddText,
  addItemClick,
  changeRandomOrder,
  minusItemClick
} from '../../topicCommonUtil'
import _ from 'lodash'
import './index.scss'
import { useRequest } from '@/utils/bhooks'
import { isDeleteOption } from '@/services/survey'
import { getParamsValue } from '@/utils/assist'
import { Message } from '@gcommon/gcommon-ui'
import { blurInput } from '../../topicCommonUtil'
import OptionSettings from '../../../SurveyDetail/compontents/optionSettings'
import VueI18n from 'vue-i18n'
import Index from '@/pages/Index'
import moment from 'moment'
import CommonTetxEdit from '@/components/CommonTetxEdit'


const RadioEdit = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    i18n: {
      type: VueI18n
    }
  },
  setup(props, context) {
    const { emit } = context
    const vm = getCurrentInstance()
    //i18n 国际化
    const tran = function (initParam) {
      return vm?.proxy.$t(initParam) as string
    }
    //为了增加操作图片的字段 加的初始化func
    // const initEditItem = (initObj) => {
    //   const inObj = _.cloneDeep(initObj)
    //   inObj?.topicSetting?.topicOptionSetting.forEach((item) => {
    //     if (item.optionName && item.optionName.includes('img')) {
    //       //具体为两个参数赋值 imgSrc  isImgFirst
    //       if (item.optionName.startsWith('<img')) {
    //         item.isImgFirst = true
    //       } else {
    //         item.isImgFirst = false
    //       }
    //       const vnode = document.createElement('div')
    //       vnode.innerHTML = item.optionName
    //       item.optionName = vnode.innerText
    //       if (vnode.childNodes.length) {
    //         item.imgSrc = Array.prototype.slice
    //           .call(vnode.childNodes)
    //           .map((ele, index) => {
    //             if (!ele.textContent) {
    //               return {
    //                 name: `$pic_{index}`,
    //                 data: ele?.attributes?.['src']?.nodeValue
    //               }
    //             }
    //           })
    //           .filter((ele) => ele)
    //       }
    //     } else {
    //       item.imgSrc = []
    //       item.isImgFirst = false
    //     }
    //   })
    //   return inObj
    // }

    const state = reactive({
      editItem: _.cloneDeep(props.item) // 图片转为富文本储存
    })
    watch(
      () => state.editItem,
      (val) => {
        emit('changeTopicContent', val)
      },
      {
        deep: true
      }
    )

    const radioInput = (value) => {
      state.editItem.value = value
      state.editItem.inputErrorTips = ''
      state.editItem.isShowInputError = false
      state.editItem.isShowTitleError = false
      state.editItem.inputValue = ''

      let options = state.editItem.topicSetting.topicOptionSetting
      options.forEach((element) => {
        state.editItem['inputErrorTips_' + element.optionId] = ''
      })

      emit('answer', state.editItem)
    }

    const focusInput = (value, sitem) => {
      let options = state.editItem.topicSetting.topicOptionSetting
      options.forEach((element) => {
        state.editItem['inputErrorTips_' + element.optionId] = ''
      })
      state.editItem.value = sitem.optionId
      emit('answer', state.editItem)
    }

    const inputChange = (value, sitem) => {
      state.editItem['inputValue_' + sitem.optionId] = value
      emit('answer', state.editItem)
    }

    const blurRadioInput = (value, sitem, state, emit) => {
      blurInput(value, sitem, state, emit)
    }

    const { state: isDeleteData, run: isDeleteOptionFn } =
      useRequest(isDeleteOption)
    const minusItemClickFn = async (index, state) => {
      await minusItemClick(index, state, isDeleteOptionFn)
    }

    const addMatrixSubtopics = (index) => {
      const option = {
        //选项设置
        optionName: '', //选项name
        optionId:'', //选项ID
        isAddText: false, //是否允许填空
        isRequire: false, //是否必填
        isEncryption: false,
        format: '', //填空格式，枚举示例（number：数字、letter：字母、chinese：中文、email：Email、phone：手机号码）
        isFixedNo: false, //是否固定选项
        key: new Date().getTime()
      }
      state.editItem.topicSetting.topicOptionSetting.splice(
        index + 1,
        0,
        option
      )
      // 给选项的order重新赋值
      state.editItem.topicSetting.topicOptionSetting.map((i, index) => {
        i.optionOrder = index + 1
      })
    }

    const deleteMatrixSubtopics = (index) => {
      if (state.editItem.topicSetting.topicOptionSetting.length < 3) {
        Message({
          message: tran('survy.choiceTips'),
          type: 'warning'
        })
      } else {
        state.editItem.topicSetting.topicOptionSetting.splice(index, 1)
      }
    }

    const optionSettingItem = reactive({
      item: state.editItem.topicSetting.topicOptionSetting?.[0],
      index: 0
    })

    return () => {
      //题目选项
      return (
        <div class="topic-edit-content">
          <div class="topic-edit-content-item topic-edit-content-title">
            {/* <div class="topic-edit-content-item-title">
              {tran('survy.singSeleName')}:
            </div>
            <RichUtil
              onchangeValue={(value) => (state.editItem.topicName = value)}
              placeholder={tran('survy.plctopicname')}

              value={state.editItem.topicName}></RichUtil> */}
            {!state.editItem.isAddStatus && (
              <div class="topic-edit-content-title-order">
                {!state.editItem.topicSetting.isAllowNull && <i>*</i>}
                {state.editItem.order}.
              </div>
            )}
            <div style={{ width: '100%' }}>
              <CommonTetxEdit
                needDynamicEvent
                initialData={state.editItem.topicName}
                placeholder={tran('survy.singSeleName')}
                handleUpdate={(value) => {
                  state.editItem.topicName = value
                }}
              />
            </div>
          </div>
          <div class="topic-edit-content-item">
            {/* <div class="topic-edit-content-item-title">
              {tran('survy.singSeleRemark')}:
            </div>
            <RichUtil
              onchangeValue={(value) =>
                (state.editItem.topicSetting.topicRemark = value)
              }
              placeholder={tran('survy.plcremark')}
              value={state.editItem.topicSetting.topicRemark}></RichUtil> */}
            {/* <el-input
              type="textarea"
              class="rich-input"
              autosize={true}
              resize="none"
              size='small'
              placeholder="请输入题目备注"
              value={state.editItem.topicSetting.topicRemark}
              onInput={(value) =>
                (state.editItem.topicSetting.topicRemark = value)
              }></el-input> */}
            <CommonTetxEdit
              needDynamicEvent
              initialData={state.editItem.topicSetting.topicRemark}
              placeholder={tran('survy.plcremark')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.topicRemark = value
              }}
            />
          </div>
          {/* {1 === 2 && (
            <div class="topic-edit-content-item">
              <el-checkbox
                value={state.editItem.topicSetting.isAllowNull}
                onInput={(value) =>
                  (state.editItem.topicSetting.isAllowNull = value)
                }>
                {tran('survy.noneedans')}
              </el-checkbox>
              <el-checkbox
                value={state.editItem.topicSetting.isRandomOrder}
                onInput={(value) => changeRandomOrder(value, state)}>
                {tran('survy.freeone')}
              </el-checkbox>
            </div>
          )}
          {1 === 2 &&
            state.editItem.topicSetting.topicOptionSetting.length > 0 && (
              <div class="topic-edit-content-item">
                <div class="topic-edit-content-item-table-header">
                  <div style={{ flex: 2 }}>{tran('survy.chosecontent')}</div>
                  <div>{tran('survy.fix')}</div>
                  <div>{tran('survy.allowemp')}</div>
                  <div>{tran('survy.noallowemp')}</div>
                  <div>{tran('survy.chartype')}</div>
                  <div>{tran('survy.getpass')}</div>
                  <div>{tran('survy.option')}</div>
                </div>
                <div class="topic-edit-content-item-table-body">
                  {state.editItem.topicSetting.topicOptionSetting.map(
                    (item, index) => {
                      return (
                        <div class="topic-edit-content-item-table-body-item">
                          <div
                            style={{ flex: 2 }}
                            class="topic-edit-content-item-table-body-item-img">
                            <el-input
                              style={
                                item.isImgFirst
                                  ? { order: '3' }
                                  : { order: '1' }
                              }
                              size="small"
                              onInput={(value) => (item.optionName = value)}
                              value={item.optionName}
                              placeholder={tran('survy.plccontent')}></el-input>
                            <div
                              style={{ order: '2', cursor: 'pointer' }}
                              class="form-item-btm-survey"
                              onClick={() => {
                                item.isImgFirst = !item.isImgFirst
                              }}>
                              <i class="el-icon-sort  el-icon-sort-rotate"></i>
                            </div>
                            {item?.imgSrc.length === 0 ? (
                              <el-upload
                                style={
                                  item.isImgFirst
                                    ? { order: '1' }
                                    : { order: '3' }
                                }
                                action="/v2/feedback/commonApi/upload?isPublic=true"
                                name="file"
                                list-type="picture"
                                show-file-list={false}
                                limit={1}
                                on-remove="handleRemove"
                                file-list={item.imgSrc}
                                // accept=
                                // on-download="handleDownload"
                                // on-preview="handlePictureCardPreview"
                                props={{
                                  'on-success': (response, file, fileList) => {
                                    // item.imgSrc[0] = {name:`pic_${index}`,data:response.data}
                                    item.imgSrc?.splice(0, 1, {
                                      name: `pic_${index}`,
                                      data: response.data
                                    })
                                    vm?.proxy.$forceUpdate()
                                  },
                                  'on-error': (err, file, fileList) => {
                                    Message({
                                      type: 'error',
                                      message: tran('survy.uoloadfail')
                                    })
                                  }
                                }}>
                                <i slot="default" class="icon-a-1 iconfont"></i>
                              </el-upload>
                            ) : (
                              <div
                                style={
                                  item.isImgFirst
                                    ? { order: '1' }
                                    : { order: '3' }
                                }
                                class="filelist_pack">
                                <img
                                  class="filelist_img"
                                  src={item.imgSrc?.[0]?.data ?? ''}
                                  width="100%"
                                  height="100%"
                                  alt
                                />
                                <div
                                  onClick={() => {
                                    item.imgSrc = []
                                  }}
                                  class="filelist_cover">
                                  <i
                                    style={{ color: 'white' }}
                                    class="el-icon-delete"></i>
                                </div>
                              </div>
                            )}
                          </div>
                          <div>
                            <el-checkbox
                              disabled={
                                !state.editItem.topicSetting.isRandomOrder
                              }
                              value={item.isFixedNo}
                              onInput={(value) =>
                                (item.isFixedNo = value)
                              }></el-checkbox>
                          </div>
                          <div>
                            <el-checkbox
                              value={item.isAddText}
                              onInput={(value) =>
                                changeIsAddText(value, index, state)
                              }></el-checkbox>
                          </div>
                          <div>
                            <el-checkbox
                              disabled={!item.isAddText}
                              value={item.isRequire}
                              onInput={(value) =>
                                (item.isRequire = value)
                              }></el-checkbox>
                          </div>
                          <div>
                            <el-select
                              clearable
                              disabled={!item.isAddText}
                              size="small"
                              onInput={(value) => (item.format = value)}
                              value={item.format}
                              placeholder={tran('survy.plcselect')}>
                              {STR_TYPE.map((sitem) => {
                                return (
                                  <el-option
                                    key={sitem.value}
                                    label={sitem.label}
                                    value={sitem.value}></el-option>
                                )
                              })}
                            </el-select>
                          </div>
                          <div>
                            <el-checkbox
                              disabled={!item.isAddText}
                              value={item.isEncryption}
                              onInput={(value) =>
                                (item.isEncryption = value)
                              }></el-checkbox>
                          </div>
                          <div class="topic-edit-content-item-table-body-item-plus">
                            <i
                              onClick={() => addItemClick(index, state)}
                              class="el-icon-circle-plus-outline"></i>
                            {state.editItem.topicSetting.topicOptionSetting
                              .length > 2 && (
                              <i
                                onClick={() => minusItemClickFn(index, state)}
                                class="el-icon-remove-outline"></i>
                            )}
                          </div>
                        </div>
                      )
                    }
                  )}
                </div>
              </div>
            )} */}
          <div class="topic-edit-content-item">
            {state.editItem.topicSetting.topicOptionSetting.map(
              (sitem, index) => {
                return (
                  <div class="option-radio" key={`${sitem.optionId?sitem.optionId:sitem.key}`} >
                    <el-radio label="">
                    </el-radio>
                    <div class="option-radio-input">
                      <CommonTetxEdit
                        initialData={sitem.optionName}
                        placeholder={tran('survy.optionName')}
                        formFocus={() => {
                          optionSettingItem.item = sitem
                          optionSettingItem.index = index
                        }}
                        handleUpdate={(value, index) => {
                          sitem.optionName = value
                        }}
                      />
                    </div>

                    {sitem.isAddText && (
                      <el-input
                        style={{ width: '220px' }}
                        size="small"
                        placeholder={tran('survy.plccontent')}></el-input>
                    )}
                    <i
                      class="el-icon-circle-plus-outline el-icon-common-class"
                      onClick={() => {
                        addMatrixSubtopics(index)
                      }}></i>
                    <i
                      class="el-icon-delete el-icon-common-class"
                      onClick={() => {
                        deleteMatrixSubtopics(index)
                      }}></i>
                  </div>
                )
              }
            )}
          </div>
          <div class="topic-edit-content-item">
            <CommonTetxEdit
              needDynamicEvent={true}
              initialData={state.editItem.topicSetting.endword}
              placeholder={tran('survy.radioend')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.endword = value
              }}
            />
          </div>
          <Portal to="survey-option-settings">
            <OptionSettings
              type={props.item.topicType}
              isAllowNull={state.editItem.topicSetting.isAllowNull}
              isRandomOrder={state.editItem.topicSetting.isRandomOrder}
              optionSettingItem={optionSettingItem}
              onChangeOptionSettingItem={(value) => {
                state.editItem.topicSetting.topicOptionSetting.splice(
                  value.index,
                  1,
                  value.item
                )
              }}
              onChangeIsAllowNull={(value) => {
                state.editItem.topicSetting.isAllowNull = value
              }}
              onChangeIsRandomOrder={(value) => changeRandomOrder(value, state)}
            />
          </Portal>
        </div>
      )
    }
  }
})
export default RadioEdit
